// Map camera, filters (shared by the map and Activities → Поруч) and the last located position
// survive leaving a tab while the app is open. In memory only: nothing here is persisted.
import type { LatLng } from '@spot/shared';

import type { MapFilters } from './filters';

export interface MapCamera {
	center: { lat: number; lng: number };
	zoom: number;
}

export interface NewEventsMemory {
	/** When the session started looking; the API returns events published after this. */
	since: string | null;
	/** The first answer only marks what exists, so a phone's wrong clock cannot raise a toast. */
	baselined: boolean;
	/** Ids on the map or already announced: never counted again. */
	seen: Set<string>;
}

export const mapMemory: {
	camera: MapCamera | null;
	filters: MapFilters;
	/** Rounded (≈100 m) viewer position (automatic on open, or the locate button). */
	position: LatLng | null;
	/** The automatic locate on the first map open already ran (once per app open). */
	autoLocated: boolean;
	/** The viewer's «Мої» choice (T-1331); null = not touched, the focus follows the 3 h rule. */
	mineFocus: boolean | null;
	/** T-1334: what the «new events» toast already knows about, for as long as the app is open. */
	newEvents: NewEventsMemory;
} = {
	camera: null,
	filters: {},
	position: null,
	autoLocated: false,
	mineFocus: null,
	newEvents: { since: null, baselined: false, seen: new Set() },
};
